import { useContext, useEffect, useState } from 'react';

import {
  FeatureFlagState,
  SeriesItem,
  SeriesSearchResponsePayload,
} from '/types';
import { MetadataContext } from '/utils/contexts';

import { useCwaAxios } from './cwaAxios';
import useFeatureFlag from './useFeatureFlag';

const useSeriesData = (): SeriesItem[] => {
  const cwaAxios = useCwaAxios();
  const { leaf_place, series } = useContext(MetadataContext);
  const cwa2786 = useFeatureFlag('cwa_2786_series_on_in_page_nav');

  const [seriesData, setSeriesData] = useState([] as SeriesItem[]);

  useEffect(() => {
    if (!series?.length || cwa2786 !== FeatureFlagState.TRUE) {
      setSeriesData([]);
      return;
    }

    cwaAxios
      .post('/api/content/series-search', {
        series,
        region: leaf_place.name,
      })
      .then((resp) => {
        const data: SeriesItem[] = resp.data.map(
          (item: SeriesSearchResponsePayload) => {
            const { slug, title, series, id } = item;
            return {
              slug,
              title,
              series,
              id,
              dateDisplay: new Date(item['date.display']),
            };
          },
        );
        // Sort the data in reverse order by date
        data.sort((x, y) => y.dateDisplay.getTime() - x.dateDisplay.getTime());
        setSeriesData(data);
      });
  }, [cwaAxios, leaf_place, series, cwa2786]);

  return seriesData;
};

export default useSeriesData;
